<template>
  <div>
    <!-- Table dialog servicios -->
    <el-dialog
      :title="title"
      :visible="isVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      top="6vh"
      width="30%"
      center
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-card>
            <el-form>
              <el-col :span="24">
                <el-form-item label="Nombre" prop="name">
                  <el-input
                    v-model="data.name"
                    autocomplete="off"
                    clearable
                    maxlength="40"
                    show-word-limit
                  >
                    <i slot="prefix" class="el-input__icon el-icon-user"></i>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="Correo" prop="email">
                  <el-input
                    v-model="data.email"
                    autocomplete="off"
                    clearable
                    maxlength="40"
                    show-word-limit
                  >
                    <i slot="prefix" class="el-input__icon el-icon-message"></i>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Contraseña">
                  <el-input
                    v-model="data.password"
                    autocomplete="off"
                    show-password
                  >
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Repite la contraseña">
                  <el-input
                    v-model="data.password"
                    autocomplete="off"
                    show-password
                  >
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="Nivel de Acceso">
                  <el-radio-group v-model="data.role" size="mini">
                    <el-radio-button label="basic">Basico</el-radio-button>
                    <el-radio-button label="supervisor"
                      >Supervisor</el-radio-button
                    >
                    <el-radio-button label="admin"
                      >Administrador</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-form>
          </el-card>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="handleSave">Crear usuario</el-button>
      </span>
    </el-dialog>
    <!-- END Table dialog servicios -->
  </div>
</template>

<script>
import { CSApi } from "@/libraries/api";

export default {
  name: "DialogUser",
  props: ["id", "isVisible"],
  data() {
    return {
      title: "",
      data: {},
    };
  },
  watch: {
    async isVisible() {
      if (this.id && this.isVisible) {
        const response = await CSApi().get(`/coverage/user/${this.id}`);
        const { data } = response.data;
        this.data = data;
        this.title = `Configuracion de`;
      } else {
        this.title = `Nuevo Usuario`;

        this.data = {
          name: "",
          email: "",
          password: "",
          role: "basic",
        };
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },

    async handleSave() {
      let options = {
        message: "Se guardaron los cambios con exito.",
        type: "success",
        duration: 4000,
      };

      try {
        let response;

        if (this.id) {
          response = await CSApi().patch(
            `/coverage/user/${this.id}`,
            this.data
          );
        } else {
          response = await CSApi().post(`/coverage/user`, this.data);
        }

        this.update();
        this.handleClose();
      } catch (error) {
        const { data, status } = error.response;
        console.log(data);
        options.message = error;
        options.type = "error";
      } finally {
        this.$message(options);
      }
    },

    update() {
      this.$emit("update");
    },
  },
};
</script>

<style></style>
